import { API_CONFIG, fetchAPI } from './api';
import type { CreditsResponse } from '@/types';

// Get user credits
export async function getCredits(email: string): Promise<number> {
  const response = await fetchAPI<CreditsResponse>(
    `${API_CONFIG.USERS_API}?action=get_credits&email=${encodeURIComponent(email)}`
  );

  if (!response.success) {
    throw new Error(response.error || 'Failed to get credits');
  }

  return response.credits;
}

export async function getCreditBalances(email: string): Promise<{ credits: number; contactCredits: number; contactCreditsResetAt?: string }> {
  const response = await fetchAPI<CreditsResponse>(
    `${API_CONFIG.USERS_API}?action=get_credits&email=${encodeURIComponent(email)}`
  );

  if (!response.success) {
    throw new Error(response.error || 'Failed to get credits');
  }

  return {
    credits: response.credits ?? 0,
    contactCredits: (response as CreditsResponse & { contactCredits?: number }).contactCredits ?? 0,
    contactCreditsResetAt: (response as CreditsResponse & { contactCreditsResetAt?: string }).contactCreditsResetAt,
  };
}

// Deduct credits
export async function deductCredits(
  email: string,
  amount: number,
  actionType: string,
  creditType: 'scrape' | 'contact' = 'scrape'
): Promise<number> {
  const response = await fetchAPI<CreditsResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'deduct_credit',
      email,
      amount,
      type: actionType,
      creditType,
    }),
  });

  if (!response.success) {
    throw new Error(response.error || 'Failed to deduct credits');
  }

  return response.credits;
}
